import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';

/**
 * Neutral transaction metadata used by agent-edit producers to request the
 * shared post-apply highlight and telepointer owned by editor-plugin-ai.
 */
export const AGENT_EDIT_CHROME_DATA = 'agentEditChromeData';

export const AGENT_EDIT_CHROME_DEFAULT_AUTO_DISMISS_AFTER_MS = 2000;
export const AGENT_EDIT_CHROME_DEFAULT_TELEPOINTER_ENABLED = true;

export type AgentEditChromeRange = {
	from: number;
	to: number;
};

export type AgentEditChromeData = {
	agentIdentityAccountId?: string;
	/** Lifetime of both the highlight and telepointer. Omission uses the shared static default; 0 prevents rendering. */
	autoDismissAfterMs?: number;
	/** Runtime CSS color value. Consumers should pass an ADS token value. */
	highlightBackgroundColor?: string;
	/** Runtime CSS color value. Consumers should pass an ADS token value. */
	highlightBorderColor?: string;
	ranges: AgentEditChromeRange[];
	/** Whether to show the telepointer. Omission uses the shared static default. */
	telepointerEnabled?: boolean;
	/** Exact telepointer label; omission uses the shared plugin's localized default. */
	telepointerLabel?: string;
};

export type AgentEditChromeDynamicConfig = {
	autoDismissAfterMs: number;
	telepointerEnabled: boolean;
};

/**
 * Resolves shared dynamic configuration at the producer boundary. The post-apply
 * chrome plugin uses the supplied values and does not read dynamic configuration itself.
 */
export const getAgentEditChromeDynamicConfig = (): AgentEditChromeDynamicConfig => ({
	autoDismissAfterMs: expVal(
		'platform_editor_agent_be_streaming',
		'highlightDurationMs',
		AGENT_EDIT_CHROME_DEFAULT_AUTO_DISMISS_AFTER_MS,
	),
	telepointerEnabled: !expVal(
		'platform_editor_agent_be_streaming',
		'telepointerDisabled',
		!AGENT_EDIT_CHROME_DEFAULT_TELEPOINTER_ENABLED,
	),
});
